import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import type {} from '@redux-devtools/extension';

import { convertToDate, isDateInstance } from '@utils';

import storage from '../storage';
import {
  answeringNavigateNextComponent,
  answeringNavigatePreviousComponent,
  findTask,
  isCareTaskExist,
  prepareAdditionalComponentAnswering,
  prepareAnswerObject,
  prepareCareTaskForAnswering,
  removeCareTask,
  resetAnswering,
  resetCareTasks,
  setTasks,
  startAnswering,
  updateAnswersBasedOnJump,
  updateCareTask,
  updateComponentAnswer,
  updateLastSeenIndex,
} from './care-task-store.actions';
import { initialState, STORE_NAME } from './care-task-store.constant';
import { CareTaskStore } from './care-task-store.types';

export const useCareTaskStore = create<CareTaskStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        findTask: findTask(get),
        setTasks: setTasks(set, get),
        removeCareTask: removeCareTask(set, get),
        isCareTaskExist: isCareTaskExist(get),
        resetCareTasks: resetCareTasks(set),
        startAnswering: startAnswering(set, get),
        resetAnswering: resetAnswering(set),
        updateCareTask: updateCareTask(set, get),
        prepareCareTaskForAnswering: prepareCareTaskForAnswering(set, get),
        answeringNavigateNextComponent: answeringNavigateNextComponent(
          set,
          get
        ),
        answeringNavigatePreviousComponent:
          answeringNavigatePreviousComponent(set),
        updateAnswersBasedOnJump: updateAnswersBasedOnJump(set),
        updateComponentAnswer: updateComponentAnswer(set, get),
        prepareAnswerObject: prepareAnswerObject(get),
        prepareAdditionalComponentAnswering:
          prepareAdditionalComponentAnswering(set, get),
        updateLastSeenIndex: updateLastSeenIndex(set, get),
      }),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => storage),
        onRehydrateStorage: () => {
          return state => {
            state?.careTasks.forEach(item => {
              const isOccurrenceIsDate = isDateInstance(
                item.template.occurrenceDate
              );
              const isOccurrenceEndIsDate = isDateInstance(
                item.template.occurrenceEndDate
              );

              state.updateCareTask(item.key, {
                template: {
                  ...item.template,
                  ...(!isOccurrenceIsDate
                    ? {
                        occurrenceDate: convertToDate(
                          item.template.occurrenceDate
                        ),
                      }
                    : {}),
                  ...(!isOccurrenceEndIsDate
                    ? {
                        occurrenceEndDate: convertToDate(
                          item.template.occurrenceEndDate
                        ),
                      }
                    : {}),
                },
              });
            });
          };
        },
      }
    ),
    {
      name: STORE_NAME,
    }
  )
);
